import { useState, useEffect } from 'react'
import { useHistory, useParams } from "react-router-dom";
import BreadCrumbs from '@components/Breadcrumbs'
import Button from '@components/Button'
import Icon from '@material-ui/core/Icon';
import Alert from '@material-ui/lab/Alert';
import Form from './Form';
import { apiClient } from '@services/api';
import { connect } from 'react-redux';

const Create = (props) => {
  document.title = `Novo veículo - ${process.env.REACT_APP_NAME}`
  const { exit_id } = useParams();
  const history = useHistory();
  const [exit, setExit] = useState({})
  const [vehicle, setVehicle] = useState({
    nickname: null,
    driver_id: null,
    guide_id: null,
    custom_driver_name: null,
    custom_guide_name: null,
    license_plate: null,
    reservation_id: null,
    type_time: 'fixed'
  })
  const [idVehicle, setIdVehicle] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const url = `/exits/${exit_id}`;

  const bradecrumbsConfig = [
    {
      title: 'Início',
      active: true,
      route: '/admin/saidas'
    },
    {
      title: `${exit?.travel_name || ''}`,
      active: true,
      route: `/admin/saidas/detalhe/${exit_id}`
    },
    {
      title: 'Novo veículo ',
    }
  ]

  const getExitsById = url => {
    apiClient.httpInstance.get(url).then(response => {
      if (response.status === 200) {
        setExit(response.data);
        setLoading(false)
      }
    });
  }

  const changeState = (ev) => {
    let value = ev.target.value
    setVehicle(
      {
        ...vehicle,
        [ev.target.name]: value

      }
    )
  }

  // Atualiza vários campos de uma vez (evita perder updates ao trocar guia/motorista por personalizado)
  const setVehicleFields = (obj) => setVehicle(v => ({ ...v, ...obj }))

  const submitExitVehicle = (ev) => {
    ev.preventDefault();
    apiClient
      .httpInstance.post(`/exits/${exit_id}/vehicles`, {
        ...vehicle,
        vehicle_id: idVehicle

      })
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          history.push(`/admin/saidas/detalhe/${exit_id}`);
        }
      })
      .catch(error => {
        if (error) {
          setError(true);
          setErrorMessage(error.response.message || "Erro inesperado, tente novamente mais tarde")
          setTimeout(() => { setError(false) }, 4000);
        }
      });
  }

  useEffect(() => {
    getExitsById(url);
  }, [url]);

  return <>
    <BreadCrumbs items={bradecrumbsConfig} />
    {!loading &&
      <>
        {error && (
          <Alert className="mb-5" variant="filled" severity="error">
            {errorMessage}
          </Alert>
        )}
        <div className="px-4 md:px-7 pt-6">
          <div className="flex flex-wrap items-center justify-between gap-2 mt-2 text-2xl text-blue">
            <span style={{ fontSize: 'calc(10px + 2vmin)' }}>Novo veículo</span>
            <Button
              textcolor="#e8f0fb"
              padding="6px 15px"
              width="200"
              variant="outlined"
              onClick={() => history.push(`/admin/saidas/detalhe/${exit_id}`)}
              bgColor="transparent"
            >
              <Icon className="mr-2">
                arrow_back
              </Icon>
              Cancelar
            </Button>
          </div>
          <Form
            {...props}
            submit={submitExitVehicle}
            vehicle={vehicle}
            idVehicle={idVehicle}
            isEditing={false}
            changeState={changeState}
            setVehicleFields={setVehicleFields}
            changeIdVehicle={setIdVehicle}
          />
        </div>
      </>
    }
  </>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(Create);
